/* Per-sub-product extra inputs for the Dati Garanzia step, keyed by sub-product slug.
   `type` must be one of the types InputByType renders:
   price | text | date | select | address | radio | percent.
   A descriptor's optional `reveals` array names other descriptors in the same list that stay
   hidden until this one holds a truthy value.

   These live in code rather than in a `cauzioni_sub_products.form_fields` column because the
   only person who can change them is a developer: there is no backoffice screen for editing
   them, so a DB column bought a migration per input and nothing else. Here a typo is caught in
   review next to the component that renders it, and adding an input is a one-line edit. If a
   backoffice editor is ever built, this moves back to the database — with a re-runnable seeder
   rather than one migration per change. */
const CAUZIONI_FORM_FIELDS = {
  rata_di_saldo: [
    { name: 'penalty_percent', type: 'percent', label: 'Percentuale penale giornaliera' },
    { name: 'additional_amount', type: 'price', label: 'Importo aggiuntivo garanzia' },
  ],
};

export const getCauzioniFormFields = (slug) => CAUZIONI_FORM_FIELDS[slug] || [];

export default CAUZIONI_FORM_FIELDS;
